import { createUrl, restPost } from '~/src/dash/api/rest';

export interface IGenieText {
  content: string;
}

export interface IGenieQuery {
  description: string;
  query: string;
}

export interface IGenieResultColumn {
  name: string;
  type_name: string;
}

export interface IGenieQueryResult {
  columns: IGenieResultColumn[];
  data_array: string[][];
}

export interface IGenieAttachment {
  attachment_id: string;
  text?: IGenieText;
  query?: IGenieQuery;
  query_result?: IGenieQueryResult;
}

export interface IGenieResponse {
  success: boolean;
  conversation_id: string;
  message_id: string;
  status: string;
  attachments: IGenieAttachment[];
  error?: string;
}

export async function askGenie(
  question: string,
  fetchResults = false,
  publisherId?: number,
  siteId?: number,
): Promise<IGenieResponse> {
  let reqUrl = createUrl('/genie/ask');
  if (publisherId) reqUrl += `&publisher_id=${publisherId}`;
  if (siteId) reqUrl += `&site_id=${siteId}`;
  const response = await restPost<IGenieResponse>(reqUrl, {
    question,
    fetch_results: fetchResults,
  });
  if (!response.parsedBody) {
    throw new Error('No response from Genie');
  }
  return response.parsedBody;
}
